import React from 'react'
import PropTypes from 'prop-types'

import { Selector } from '@leverege/ui-elements';

export default class ProjectSelector extends React.Component {

  static propTypes = {
    onSelect : PropTypes.func,
    current : PropTypes.string,
    projects : PropTypes.object,
    filter : PropTypes.array
  }
  
  constructor( props ) {
    super( props );
    this.onSelect = this.onSelect.bind( this );
  }

  onSelect( { value : project } ) {
    if ( this.props.onSelect ) {
      this.props.onSelect( project );
    }
  }

  render() {
    const { projects, current, onSelect, filter } = this.props
    let arr = ( projects && projects.projects ) || []

    arr = ( [].concat( arr ) ).sort( sort )

    const values = [ ]
    arr.forEach( ( t ) => {
      if ( filter == null || filter.indexOf( t.id ) < 0 ) {
        values.push( { name : t.name, value : t.id, project : t } )
      }
    } )
            
    return (
      <Selector
        values={values}
        value={current}
        placeholder="No Project"
        onChange={this.onSelect} />
    )
  }

}

function sort( a, b ) {
  return a.name > b.name
}
